import { combineReducers } from "redux";
import alert from "../alert/alertReducer";
import loader from "../loader/loaderReducer";
import sidebar from "../sidebar/sidebarReducer";
import auth from "../auth/authReducer";
import otpVerification from "../otpverification/otpVerificationReducer";
import { routerReducer } from "react-router-redux";
import master from "../master/masterReducer";
import userManagement from "../userManagement/userManagementReducer";
import mobileUserManagement from "../mobileAppUserManagement/mobileAppUserManagementReducer";
import youtubeManagement from "../YouTubeManagement/YouTubeManagementReducer";
import instagramManagement from "../InstagramManagement/InstagramManagementReducer";
import bannerManagement from "../BannerManagement/BannerManagementReducer";
import subscriptionManagement from "../Subscription/SubscriptionManagementReducer";
import notificationManagement from "../notificationManagement/notificationManagementReducer";

// export const rootReducer = combineReducers({
//   // router: connectRouter(history),
//   router: routerReducer,
//   alert,
//   auth,
//   loader,
//   sidebar,
//   otpVerification,
//   //
//   master,
//   userManagement,
//   mobileUserManagement,
//   youtubeManagement,
//   instagramManagement,
//   bannerManagement,
//   subscriptionManagement,
//   notificationManagement,
// });

export const rootReducer = (state, action) => {
  if (action.type === "LOGOUT_SUCCESS") {
    // Clear all state except for persisted reducers
    state = undefined; // `redux-persist` will handle retaining the whitelist states
  }
  return combineReducers({
    router: routerReducer,
    alert,
    auth,
    loader,
    sidebar,
    otpVerification,
    master,
    userManagement,
    mobileUserManagement,
    youtubeManagement,
    instagramManagement,
    bannerManagement,
    subscriptionManagement,
    notificationManagement,
  })(state, action);
};
